<template>
    <div class="container">
        <div class="search" style="display:flex">
            <el-form ref="queryFormRef" style="flex:1" :inline="true" :model="search" class="demo-form-inline"
                size="mini">
                <el-form-item label="SIM ID：" prop="sim_id">
                    <el-input v-model.trim="search.sim_id" placeholder=" " @keyup.enter="Search"></el-input>
                </el-form-item>
                <el-form-item label="UUID：" prop="uuid">
                    <el-input v-model.trim="search.uuid" placeholder=" " @keyup.enter="Search"></el-input>
                </el-form-item>
                <el-form-item label="UID：" prop="uid">
                    <el-input v-model.trim="search.uid" placeholder=" " @keyup.enter="Search"></el-input>
                </el-form-item>
                <el-form-item label="类型：" prop="type">
                    <el-select clearable v-model="search.type" @change="Search">
                        <el-option label="全部" value=""></el-option>
                        <el-option label="配套SIM卡" :value="0"></el-option>
                        <el-option label="非配套SIM卡" :value="1"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" style="margin-left: 16px;" class="btnClass" @click="Search">搜索</el-button>
                    <el-button type="text" class="textBtn" style="padding-bottom: 0px;vertical-align: bottom;"
                        @click="clearCondition">重置</el-button>
                </el-form-item>
            </el-form>
        </div>
        <!-- 列表 -->
        <el-table :data="list" size="mini">
            <el-table-column label="ID" min-width="80">
                <template v-slot="scope">
                    <span>{{ scope.row.id }}</span>
                </template>
            </el-table-column>
            <el-table-column label="SIM ID" min-width="160" show-overflow-tooltip>
                <template v-slot="scope">
                    <span>{{ scope.row.sim_id }}</span>
                </template>
            </el-table-column>
            <el-table-column label="UID" min-width="140" show-overflow-tooltip>
                <template v-slot="scope">
                    <span>{{ scope.row.uid }}</span>
                </template>
            </el-table-column>
            <el-table-column label="UUID" min-width="180" show-overflow-tooltip>
                <template v-slot="scope">
                    <span>{{ scope.row.uuid }}</span>
                </template>
            </el-table-column>
            <el-table-column label="类型" min-width="120">
                <template v-slot="scope">
                    <span>{{ getTypeText(scope.row.type) }}</span>
                </template>
            </el-table-column>
            <el-table-column label="状态" min-width="100">
                <template v-slot="scope">
                    <span>{{ getStatusText(scope.row.status) }}</span>
                </template>
            </el-table-column>
            <el-table-column label="绑定时间" min-width="140">
                <template v-slot="scope">
                    <span>{{ scope.row.bind_time ? util.dateFormat(scope.row.bind_time) : '--:--:--' }}</span>
                </template>
            </el-table-column>
            <el-table-column label="删除人" min-width="120" show-overflow-tooltip>
                <template v-slot="scope">
                    <span>{{ scope.row.del_by }}</span>
                </template>
            </el-table-column>
            <el-table-column label="删除时间" min-width="140">
                <template v-slot="scope">
                    <span>{{ scope.row.del_time ? util.dateFormat(scope.row.del_time) : '--:--:--' }}</span>
                </template>
            </el-table-column>
            <el-table-column label="创建时间" min-width="160">
                <template v-slot="scope">
                    <span>{{ scope.row.created_at }}</span>
                </template>
            </el-table-column>
            <el-table-column label="更新时间" min-width="160">
                <template v-slot="scope">
                    <span>{{ scope.row.updated_at }}</span>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination @current-change="handleCurrentChange" v-model:currentPage="search.page" :page-size="search.limit"
            layout="total, prev, pager, next" :total="total" background>
        </el-pagination>
    </div>
</template>

<script type="text/ecmascript-6">
import util from '../../../util/util'

export default {
    name: 'simlist',
    mixins: [],
    components: {},
    props: {},
    data() {
        return {
            util: util,
            search: {
                page: 1,
                limit: 16,
                sim_id: '',
                uuid: '',
                uid: '',
                type: ''
            },
            list: [],
            total: 0
        }
    },
    computed: {},
    watch: {},
    methods: {
        handleCurrentChange(val) {
            this.search.page = val
            this.Search()
        },
        Search() {
            let filter = {
                ...this.search
            }
            this.api.SimList(filter).then(res => {
                if (res.data.code == 200) {
                    this.list = res.data.data.data || res.data.data.list || []
                    this.total = res.data.data.page_info?.total || 0
                    return
                }
                this.$message.error('获取失败' + res.data.msg)
            })
        },
        clearCondition() {
            this.reset()
            this.Search()
        },
        reset() {
            this.search = {
                ...this.search,
                sim_id: '',
                uuid: '',
                uid: '',
                type: ''
            }
        },
        getTypeText(type) {
            const typeMap = {
                0: '配套SIM卡',
                1: '非配套SIM卡'
            }
            return typeMap[type] || '未知'
        },
        getStatusText(status) {
            const statusMap = {
                1: '已绑定',
                2: '已解绑'
            }
            return statusMap[status] || '未知'
        }
    },
    filters: {},
    mounted() {
        this.Search()
    },
    created() {}
}
</script>

<style scoped lang="stylus" rel="stylesheet/stylus">
.container {
	font-family: 'Manrope';
	font-style: normal;
	font-weight: 400;
	font-size: 14px;
	.search {
		background: #F0F2F5;
		padding-top: 16px;
		margin-bottom: 24px;
	}
	.el-form {
		::v-deep(.el-form-item__label) {
			font-family: 'Manrope';
			font-style: normal;
			font-weight: 400;
			font-size: 14px;
			color: #000000;
            opacity: 0.8;
			padding-right: 0px;
		}
		.el-form-item {
			margin-left: 24px;
		}
	}
	.btnClass {
		color: #FFF;
		background-color: #FB6D07;
		border-color: #FB6D07;
	}
	.textBtn {
		color: #FB6D07;
	}
	::v-deep(thead) {
		font-family: 'Manrope';
		font-style: normal;
		font-weight: 400;
		font-size: 14px;
		color: #000;
		opacity: 0.8;
		th {
			font-weight: 400;
			background-color: #F0F2F5;
		}
	}
  ::v-deep(tbody) {
    tr {
      font-family: 'Manrope';
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      color: #000000;
      opacity: 0.8;
    }
  }
}
</style>
